import React from 'react';
import { Spinner, Container } from 'react-bootstrap';

const LoadingSpinner = ({ message = 'Loading...', fullScreen = false }) => {
  if (fullScreen) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center">
          <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
          <div className="mt-3">{message}</div>
        </div>
      </Container>
    );
  }

  return (
    <div className="text-center py-5">
      <Spinner animation="border" variant="primary" />
      <div className="mt-2">{message}</div>
    </div>
  );
};

export default LoadingSpinner;
